<mat-form-field class="w-100">
  @if (label) {
    <mat-label [innerHTML]="label" class="condensed-label-view"></mat-label>
  }
  <input 
    type="text"
    [disabled]="isDisabled"
    [readonly]="isDisabled"
    [attr.aria-label]="ariaLabel || null"
    matInput
    [formControl]="inputControl"
    [value]="inputDisplayValue()"
    [matAutocomplete]="auto"
    #autocompleteTrigger="matAutocompleteTrigger"
    [matAutocompleteDisabled]="isDisabled"
    [attr.aria-busy]="loading && hasFocus() && autocompleteTrigger.panelOpen"
    (focus)="hasFocus.set(true); onInteraction()"
    (blur)="hasFocus.set(false)"
    (click)="onInteraction()"
    (keydown)="onKeydown($event)"
    [placeholder]="placeholder">
  <mat-icon matSuffix style="cursor: pointer;" svgIcon="menu-down"></mat-icon>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (opened)="onInteraction()">
    @if (loading) {
      <mat-option disabled>
        <span class="assignment-loading-option">
          <mat-spinner diameter="20" aria-hidden="true"></mat-spinner>
          <span>Loading eligible users...</span>
        </span>
      </mat-option>
    } @else {
    @for (option of filteredOptions(); track option) {
      <mat-option [value]="option">{{option.displayName}}</mat-option>
    }
    }
  </mat-autocomplete>
  <mat-hint class="condensed-help-text" [innerHTML]="helpText" *ngIf="helpText"></mat-hint>
  <mat-error *ngIf="showError">required</mat-error>
</mat-form-field>